import Vue from 'vue' ;
import Router from 'vue-router';

// 路由组件
import error from '@/pages/error';
import mainFrame from '@/pages/mainFrame';
import home from '@/pages/home/index';
import login from '@/pages/login/index';

// 数据大屏
import datav from '@/pages/datav/frame';
import datavHead from '@/pages/datav/head';
import datavParkHeadquarters from '@/pages/datav/park-headquarters';
import datavFactoryEplus from '@/pages/datav/factory-eplus';
import datavParkYongdong from '@/pages/datav/park-yongdong';
import datavParkGejiachecun from '@/pages/datav/park-gejiachecun';
import datavEpivg from '@/pages/datav/epivg';

// 产能数据
import capacity from '@/pages/capacity/frame';
import capacityProductionList from '@/pages/capacity/production-list';
import capacityDeliveryList from '@/pages/capacity/delivery-list';
import capacityCompanyList from '@/pages/capacity/company-list';

//系统管理
import system from '@/pages/system/frame';//外层架子；
import leftMenuManager from '@/pages/system/leftMenuManager';
import userManager from '@/pages/system/userManager';
import roleManager from '@/pages/system/roleManager';
import functionManager from '@/pages/system/functionManager';
//公共
import editPwd from '@/pages/commonPage/editPwd'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect:'/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta:{title:'登录'}
    },
    {
      path: '/mainFrame',
      name: 'mainFrame',
      component: mainFrame,
      children:[
        {
          path: '/404',
          name: 'error',
          component: error,
          meta:{title:'404'}
        },
        {
          path: '/home',
          name: 'home',
          component: home,
          meta:{title:'首页',isShowBread:false,matchLeftKey:'/home'}
        },
        {
          path: '/datav',
          name: 'datav',
          component: datav,
          meta:{title:'数据可视化'},
          children:[
            {
              path: 'head',
              name: 'datavHead',
              component: datavHead,
              meta:{title:'总大屏',isShowBread:true,matchLeftKey:'/datav/head'}
            },
            {
              path: 'headquarters',
              name: 'datavParkHeadquarters',
              component: datavParkHeadquarters,
              meta:{title:'总部园区',isShowBread:true,matchLeftKey:'/datav/headquarters'}
            },
            {
              path: 'factoryEplus',
              name: 'datavFactoryEplus',
              component: datavFactoryEplus,
              meta:{title:'E+工厂',isShowBread:true,matchLeftKey:'/datav/factoryEplus'}
            },
            {
              path: 'parkYongdong',
              name: 'datavParkYongdong',
              component: datavParkYongdong,
              meta:{title:'永东创艺园',isShowBread:true,matchLeftKey:'/datav/parkYongdong'}
            },
            {
              path: 'parkGejiachecun',
              name: 'datavParkGejiachecun',
              component: datavParkGejiachecun,
              meta:{title:'葛家车智造园',isShowBread:true,matchLeftKey:'/datav/parkGejiachecun'}
            },
			{
			  path: 'epivg',
			  name: 'datavEpivg',
			  component: datavEpivg,
			  meta:{title:'Epivg数据大屏',isShowBread:true,matchLeftKey:'/datav/epivg'}
			}
          ]
        },
        {
          path: '/capacity',
          name: 'capacity',
          component: capacity,
          meta:{ title: '产能数据' },
          children:[
            {
              path: 'productionList',
              name: 'capacityProductionList',
              component: capacityProductionList,
              meta:{title:'投产数据', isShowBread:true, matchLeftKey:'/capacity/productionList'}
            },
            {
              path: 'deliveryList',
              name: 'capacityDeliveryList',
              component: capacityDeliveryList,
              meta:{title:'交货数据', isShowBread:true, matchLeftKey:'/capacity/deliveryList'}
            },
            {
              path: 'companyList',
              name: 'capacityCompanyList',
              component: capacityCompanyList,
              meta:{title:'企业名单', isShowBread:true, matchLeftKey:'/capacity/companyList'}
            },
          ]
        },
        //公共
        {
            path: '/editPwd',
            name: 'editPwd',
            component: editPwd
        },
        //系统管理
        {
          path:'/system',
          name:'system',
          component:system,
          meta:{title:"系统管理"},
          children:[
            {
                path: 'leftMenuManager',
                name: 'leftMenuManager',
                component: leftMenuManager,
                meta:{title:'菜单管理',isShowBread:true,matchLeftKey:'/system/leftMenuManager'}
            },
             {
                path: 'userManager',
                name: 'userManager',
                component: userManager,
                meta:{title:'用户管理',isShowBread:true,matchLeftKey:'/system/userManager'}
            },
            {
                path: 'roleManager',
                name: 'roleManager',
                component: roleManager,
                meta:{title:'角色管理',isShowBread:true,matchLeftKey:'/system/roleManager'}
            },
            {
                path: 'functionManager',
                name: 'functionManager',
                component: functionManager,
                meta:{title:'功能配置',isShowBread:true,matchLeftKey:'/system/functionManager'}
            }
          ]

        }

      ]
    },
    {
        path: '*',
        redirect: '/404'
    },

  ]
})
function getCookie(cname)
{
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++)
  {
    var c = ca[i].trim();
    if (c.indexOf(name)==0) return c.substring(name.length,c.length);
  }
  return "";
}
router.beforeEach((to, from, next) => {
    // if(window.gtag){
    //   gtag('config', 'xxxx', {'page_path': to.fullPath})
    // }
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    } else {
        document.title = "数据可视化管理后台"
    }
    next();
})
router.afterEach((to, from) => {
    function restartLogin() {
        // Message({
        //     message: "请先登录~",
        //     type: 'warning',
        //     duration: 1500
        // });
        setTimeout(function() {
            router.replace("/login")
        }, 100)
    }
    // console.log(to, from)
    let isLogined = getCookie("isLoginedSZHC")
    console.log("isLogined:"+isLogined)
    if (to.name != 'login' && isLogined != 'y') {
        restartLogin()
    }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js